/**
 * ONE Request UI API
 * Rest API definition for ONE Request UI. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: toannhanb7@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { BooleanResponse } from '../model/models';
import { FileInfo } from '../model/models';
import { OneRequest } from '../model/models';
import { RequestActivity } from '../model/models';
import { RequestApproval } from '../model/models';
import { RequestGetAllResult } from '../model/models';
import { RequestStatusBody } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class RequestService {

    protected basePath = 'http://localhost/api/pri';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Add Request To Favorite List
     * @param xTENANTID 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addRequestFavorite(xTENANTID: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BooleanResponse>;
    public addRequestFavorite(xTENANTID: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BooleanResponse>>;
    public addRequestFavorite(xTENANTID: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BooleanResponse>>;
    public addRequestFavorite(xTENANTID: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling addRequestFavorite.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling addRequestFavorite.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<BooleanResponse>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/favorite`,
            null,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Add Followers to Request
     * @param xTENANTID 
     * @param id 
     * @param requestBody 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addRequestFollowers(xTENANTID: string, id: number, requestBody?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<OneRequest>;
    public addRequestFollowers(xTENANTID: string, id: number, requestBody?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<OneRequest>>;
    public addRequestFollowers(xTENANTID: string, id: number, requestBody?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<OneRequest>>;
    public addRequestFollowers(xTENANTID: string, id: number, requestBody?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling addRequestFollowers.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling addRequestFollowers.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<OneRequest>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/followers`,
            requestBody,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create Request
     * @param xTENANTID 
     * @param oneRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRequest(xTENANTID: string, oneRequest?: OneRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<OneRequest>;
    public createRequest(xTENANTID: string, oneRequest?: OneRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<OneRequest>>;
    public createRequest(xTENANTID: string, oneRequest?: OneRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<OneRequest>>;
    public createRequest(xTENANTID: string, oneRequest?: OneRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling createRequest.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<OneRequest>(`${this.configuration.basePath}/requests`,
            oneRequest,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export all request to excel files
     * @param xTENANTID 
     * @param search 
     * @param page 
     * @param size 
     * @param fullData 
     * @param requestGroup 
     * @param status 
     * @param toMe 
     * @param fromMe 
     * @param followed 
     * @param favorite 
     * @param createdDate 
     * @param end 
     * @param creators 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportAllRequests(xTENANTID: string, search?: string, page?: number, size?: number, fullData?: boolean, requestGroup?: number, status?: 'Pending' | 'Approved' | 'Rejected' | 'Timeout' | 'Cancelled', toMe?: boolean, fromMe?: boolean, followed?: boolean, favorite?: boolean, createdDate?: number, end?: number, creators?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<Blob>;
    public exportAllRequests(xTENANTID: string, search?: string, page?: number, size?: number, fullData?: boolean, requestGroup?: number, status?: 'Pending' | 'Approved' | 'Rejected' | 'Timeout' | 'Cancelled', toMe?: boolean, fromMe?: boolean, followed?: boolean, favorite?: boolean, createdDate?: number, end?: number, creators?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public exportAllRequests(xTENANTID: string, search?: string, page?: number, size?: number, fullData?: boolean, requestGroup?: number, status?: 'Pending' | 'Approved' | 'Rejected' | 'Timeout' | 'Cancelled', toMe?: boolean, fromMe?: boolean, followed?: boolean, favorite?: boolean, createdDate?: number, end?: number, creators?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public exportAllRequests(xTENANTID: string, search?: string, page?: number, size?: number, fullData?: boolean, requestGroup?: number, status?: 'Pending' | 'Approved' | 'Rejected' | 'Timeout' | 'Cancelled', toMe?: boolean, fromMe?: boolean, followed?: boolean, favorite?: boolean, createdDate?: number, end?: number, creators?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling exportAllRequests.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (search !== undefined && search !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>search, 'search');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>size, 'size');
        }
        if (fullData !== undefined && fullData !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>fullData, 'fullData');
        }
        if (requestGroup !== undefined && requestGroup !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>requestGroup, 'requestGroup');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }
        if (toMe !== undefined && toMe !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>toMe, 'toMe');
        }
        if (fromMe !== undefined && fromMe !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>fromMe, 'fromMe');
        }
        if (followed !== undefined && followed !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>followed, 'followed');
        }
        if (favorite !== undefined && favorite !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>favorite, 'favorite');
        }
        if (createdDate !== undefined && createdDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>createdDate, 'createdDate');
        }
        if (end !== undefined && end !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>end, 'end');
        }
        if (creators) {
            creators.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'creators');
            })
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/csv',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vndms-excel',
                'image/gif',
                'text/html',
                'image/vnd.microsoft.icon',
                'text/calendar',
                'image/jpeg',
                'application/vnd.oasis.opendocument.presentation',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/pdf',
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.post(`${this.configuration.basePath}/requests/export`,
            null,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export request form
     * @param xTENANTID 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportRequestForm(xTENANTID: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<Blob>;
    public exportRequestForm(xTENANTID: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public exportRequestForm(xTENANTID: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public exportRequestForm(xTENANTID: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling exportRequestForm.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportRequestForm.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/csv',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vndms-excel',
                'image/gif',
                'text/html',
                'image/vnd.microsoft.icon',
                'text/calendar',
                'image/jpeg',
                'application/vnd.oasis.opendocument.presentation',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/pdf',
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/files/exportForm`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Activity logs of Request
     * @param xTENANTID 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActivityLogs(xTENANTID: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<RequestActivity>>;
    public getActivityLogs(xTENANTID: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<RequestActivity>>>;
    public getActivityLogs(xTENANTID: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<RequestActivity>>>;
    public getActivityLogs(xTENANTID: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling getActivityLogs.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getActivityLogs.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<RequestActivity>>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/activties`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all Requests
     * @param xTENANTID 
     * @param search 
     * @param page 
     * @param size 
     * @param fullData 
     * @param requestGroup 
     * @param status 
     * @param toMe 
     * @param fromMe 
     * @param followed 
     * @param favorite 
     * @param createdDate 
     * @param end 
     * @param creators 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllRequests(xTENANTID: string, search?: string, page?: number, size?: number, fullData?: boolean, requestGroup?: number, status?: 'Pending' | 'Approved' | 'Rejected' | 'Timeout' | 'Cancelled', toMe?: boolean, fromMe?: boolean, followed?: boolean, favorite?: boolean, createdDate?: number, end?: number, creators?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<RequestGetAllResult>;
    public getAllRequests(xTENANTID: string, search?: string, page?: number, size?: number, fullData?: boolean, requestGroup?: number, status?: 'Pending' | 'Approved' | 'Rejected' | 'Timeout' | 'Cancelled', toMe?: boolean, fromMe?: boolean, followed?: boolean, favorite?: boolean, createdDate?: number, end?: number, creators?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<RequestGetAllResult>>;
    public getAllRequests(xTENANTID: string, search?: string, page?: number, size?: number, fullData?: boolean, requestGroup?: number, status?: 'Pending' | 'Approved' | 'Rejected' | 'Timeout' | 'Cancelled', toMe?: boolean, fromMe?: boolean, followed?: boolean, favorite?: boolean, createdDate?: number, end?: number, creators?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<RequestGetAllResult>>;
    public getAllRequests(xTENANTID: string, search?: string, page?: number, size?: number, fullData?: boolean, requestGroup?: number, status?: 'Pending' | 'Approved' | 'Rejected' | 'Timeout' | 'Cancelled', toMe?: boolean, fromMe?: boolean, followed?: boolean, favorite?: boolean, createdDate?: number, end?: number, creators?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling getAllRequests.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (search !== undefined && search !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>search, 'search');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>size, 'size');
        }
        if (fullData !== undefined && fullData !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>fullData, 'fullData');
        }
        if (requestGroup !== undefined && requestGroup !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>requestGroup, 'requestGroup');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }
        if (toMe !== undefined && toMe !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>toMe, 'toMe');
        }
        if (fromMe !== undefined && fromMe !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>fromMe, 'fromMe');
        }
        if (followed !== undefined && followed !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>followed, 'followed');
        }
        if (favorite !== undefined && favorite !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>favorite, 'favorite');
        }
        if (createdDate !== undefined && createdDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>createdDate, 'createdDate');
        }
        if (end !== undefined && end !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>end, 'end');
        }
        if (creators) {
            creators.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'creators');
            })
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<RequestGetAllResult>(`${this.configuration.basePath}/requests`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get attachment file in Request
     * @param xTENANTID 
     * @param id 
     * @param fileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAttachment(xTENANTID: string, id: number, fileId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<Blob>;
    public getAttachment(xTENANTID: string, id: number, fileId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<HttpResponse<Blob>>;
    public getAttachment(xTENANTID: string, id: number, fileId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<HttpEvent<Blob>>;
    public getAttachment(xTENANTID: string, id: number, fileId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/csv' | 'application/msword' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'application/vndms-excel' | 'image/gif' | 'text/html' | 'image/vnd.microsoft.icon' | 'text/calendar' | 'image/jpeg' | 'application/vnd.oasis.opendocument.presentation' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/pdf' | 'application/octet-stream'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling getAttachment.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getAttachment.');
        }
        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling getAttachment.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/csv',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vndms-excel',
                'image/gif',
                'text/html',
                'image/vnd.microsoft.icon',
                'text/calendar',
                'image/jpeg',
                'application/vnd.oasis.opendocument.presentation',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/pdf',
                'application/octet-stream'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/files/${encodeURIComponent(String(fileId))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get attachment file info
     * @param xTENANTID 
     * @param id 
     * @param fileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAttachmentInfo(xTENANTID: string, id: number, fileId: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<FileInfo>>;
    public getAttachmentInfo(xTENANTID: string, id: number, fileId: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<FileInfo>>>;
    public getAttachmentInfo(xTENANTID: string, id: number, fileId: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<FileInfo>>>;
    public getAttachmentInfo(xTENANTID: string, id: number, fileId: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling getAttachmentInfo.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getAttachmentInfo.');
        }
        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling getAttachmentInfo.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (fileId) {
            fileId.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'fileId');
            })
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<FileInfo>>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/files/info`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a Request
     * @param xTENANTID 
     * @param id 
     * @param fullData 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRequest(xTENANTID: string, id: number, fullData?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<OneRequest>;
    public getRequest(xTENANTID: string, id: number, fullData?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<OneRequest>>;
    public getRequest(xTENANTID: string, id: number, fullData?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<OneRequest>>;
    public getRequest(xTENANTID: string, id: number, fullData?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling getRequest.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRequest.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (fullData !== undefined && fullData !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>fullData, 'fullData');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<OneRequest>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get request activity log
     * Get request activity log
     * @param xTENANTID 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRequestAcitivyLogs(xTENANTID: string, id: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<{ [key: string]: RequestApproval; }>;
    public getRequestAcitivyLogs(xTENANTID: string, id: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<{ [key: string]: RequestApproval; }>>;
    public getRequestAcitivyLogs(xTENANTID: string, id: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<{ [key: string]: RequestApproval; }>>;
    public getRequestAcitivyLogs(xTENANTID: string, id: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling getRequestAcitivyLogs.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRequestAcitivyLogs.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (id) {
            id.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'id');
            })
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<{ [key: string]: RequestApproval; }>(`${this.configuration.basePath}/request/approvalInfo`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove Request
     * @param xTENANTID 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeRequest(xTENANTID: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BooleanResponse>;
    public removeRequest(xTENANTID: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BooleanResponse>>;
    public removeRequest(xTENANTID: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BooleanResponse>>;
    public removeRequest(xTENANTID: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling removeRequest.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeRequest.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.delete<BooleanResponse>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove Request from Favorite List
     * @param xTENANTID 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeRequestFavorite(xTENANTID: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BooleanResponse>;
    public removeRequestFavorite(xTENANTID: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BooleanResponse>>;
    public removeRequestFavorite(xTENANTID: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BooleanResponse>>;
    public removeRequestFavorite(xTENANTID: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling removeRequestFavorite.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeRequestFavorite.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.delete<BooleanResponse>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/favorite`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove Followers from Request
     * @param xTENANTID 
     * @param id 
     * @param follower 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeRequestFollowers(xTENANTID: string, id: number, follower: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<OneRequest>;
    public removeRequestFollowers(xTENANTID: string, id: number, follower: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<OneRequest>>;
    public removeRequestFollowers(xTENANTID: string, id: number, follower: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<OneRequest>>;
    public removeRequestFollowers(xTENANTID: string, id: number, follower: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling removeRequestFollowers.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeRequestFollowers.');
        }
        if (follower === null || follower === undefined) {
            throw new Error('Required parameter follower was null or undefined when calling removeRequestFollowers.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (follower) {
            follower.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'follower');
            })
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.delete<OneRequest>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/followers`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update Request
     * @param xTENANTID 
     * @param id 
     * @param oneRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRequest(xTENANTID: string, id: number, oneRequest?: OneRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<OneRequest>;
    public updateRequest(xTENANTID: string, id: number, oneRequest?: OneRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<OneRequest>>;
    public updateRequest(xTENANTID: string, id: number, oneRequest?: OneRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<OneRequest>>;
    public updateRequest(xTENANTID: string, id: number, oneRequest?: OneRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling updateRequest.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateRequest.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<OneRequest>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}`,
            oneRequest,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * update request status
     * @param xTENANTID 
     * @param id 
     * @param requestStatusBody 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRequestStatus(xTENANTID: string, id: number, requestStatusBody?: RequestStatusBody, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BooleanResponse>;
    public updateRequestStatus(xTENANTID: string, id: number, requestStatusBody?: RequestStatusBody, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BooleanResponse>>;
    public updateRequestStatus(xTENANTID: string, id: number, requestStatusBody?: RequestStatusBody, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BooleanResponse>>;
    public updateRequestStatus(xTENANTID: string, id: number, requestStatusBody?: RequestStatusBody, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling updateRequestStatus.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateRequestStatus.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<BooleanResponse>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/status`,
            requestStatusBody,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Visit the request
     * @param xTENANTID 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public visitRequest(xTENANTID: string, id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BooleanResponse>;
    public visitRequest(xTENANTID: string, id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BooleanResponse>>;
    public visitRequest(xTENANTID: string, id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BooleanResponse>>;
    public visitRequest(xTENANTID: string, id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (xTENANTID === null || xTENANTID === undefined) {
            throw new Error('Required parameter xTENANTID was null or undefined when calling visitRequest.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling visitRequest.');
        }

        let headers = this.defaultHeaders;
        if (xTENANTID !== undefined && xTENANTID !== null) {
            headers = headers.set('X-TENANT-ID', String(xTENANTID));
        }

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<BooleanResponse>(`${this.configuration.basePath}/request/${encodeURIComponent(String(id))}/visited`,
            null,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
